import React from 'react';
import {useUsersByClientAllQuery} from 'api';
import useSearchParams from '../useSearchParams';

export const AssigneeFilter: React.FC = () => {
  const {query, setQuery} = useSearchParams();

  const {data: {usersByClientAll: {users = []} = {}} = {}} =
    useUsersByClientAllQuery({
      variables: {
        search: {
          active: true,
        },
      },
    });

  const assignee = query.assignee ?? 'all';

  const handleAssigneeChange = (value: string) => {
    setQuery({assignee: value === 'all' ? undefined : value});
  };

  return (
    <div className="relative">
      <select
        value={assignee}
        onChange={(e) => handleAssigneeChange(e.target.value)}
        className="h-8 px-2 pr-6 text-xs font-bold border border-c-border rounded bg-white text-c-text-primary appearance-none min-w-[80px]">
        <option value="all">すべて</option>
        {users.map((user) => (
          <option key={user.id} value={user.id}>
            {user.lastName} {user.firstName}
          </option>
        ))}
      </select>
      <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none">
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.33 2.67L4 5.33L6.67 2.67"
            stroke="#4D4D4D"
            strokeWidth="1.5"
            fill="none"
          />
        </svg>
      </div>
    </div>
  );
};

